<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="pagevii">
<p class="dedicationText"><em class="italic">For Dad</em></p>
</a><a id="pageviii">
</a></div><a id="pageviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416594161_ded01.vue?7acfc5fc